module.exports = __webpack_public_path__ + "img/num_16.2a5173b4.png";